import React from 'react';

import { Sidebar } from '@src/components/Sidebar';

export const MainLayout = ({ children }) => <Sidebar>{children}</Sidebar>;
